import { InfiniteData, QueryClient, QueryKey } from '@tanstack/react-query';
import { CartBuyerModel, PackageSellerDraftModel } from '@steelbuy/ts-shared';
import { ResponseModel } from './types';

export const removeItemFromCache = (queryClient: QueryClient, cacheKey: QueryKey, removeId: string) => {
    queryClient.setQueryData(
        cacheKey,
        (cachedDraftPackages: InfiniteData<ResponseModel<PackageSellerDraftModel[]>> | undefined) => {
            if (!cachedDraftPackages) {
                return;
            }
            // eslint-disable-next-line consistent-return
            return {
                ...cachedDraftPackages,
                pages: cachedDraftPackages.pages.map((page) => ({
                    ...page,
                    total: page.total - 1,
                    items: page.items.filter((item) => item.id !== removeId),
                })),
            };
        }
    );
};

export const updateCartCache = (queryClient: QueryClient, cacheKey: QueryKey, data: CartBuyerModel) => {
    queryClient.setQueryData<CartBuyerModel>(cacheKey, () => data);
};
